import { PluginHelper, useFindLayoutCells, } from "@plansoft-configuration-renderer/layout";
import { AttributeBaseType } from "../../AttributeComponents/AttributeBaseType";
import { ConfigurationComponentType } from "../ConfigurationComponentType";
const relevantPluginIds = [
    AttributeBaseType.Substructure,
    AttributeBaseType.Editable,
    AttributeBaseType.Boolean,
    AttributeBaseType.MultiOption,
    AttributeBaseType.SingleOption,
    ConfigurationComponentType.AttributeGroup,
];
/**
 * Get layout cells for attributes
 * @category UI
 * @param props
 * @returns
 */
export function useAttributeOrGroupLayoutCells() {
    return useFindLayoutCells((cell, depth) => {
        const pluginId = PluginHelper.getPluginId(cell);
        if (!pluginId) {
            return false;
        }
        // only retrieve top level groups
        if (depth > 1) {
            return false;
        }
        return relevantPluginIds.includes(pluginId);
    });
}
//# sourceMappingURL=useAttributeOrGroupLayoutCells.js.map